import React from 'react'
import { COLORS } from '../../../../styles/colors'
import { DayCellProps } from '../../types'
import { DayCellContent, RangeArrow, StyledDayCell } from './DayCell.styles'

/**
 * Компонент ячейки дня в календаре
 *
 * Автоматически определяет свое визуальное состояние на основе props:
 * - Серый и disabled для дат не из текущего месяца
 * - Фиолетовая обводка для сегодняшнего дня
 * - Фиолетовый фон для выбранной даты
 * - Светло-фиолетовый фон для дат в диапазоне
 * - Темно-фиолетовый фон для начала/конца диапазона с "стрелочками"
 */
const DayCell: React.FC<DayCellProps> = ({
	date,
	isSelected,
	isToday,
	isCurrentMonth,
	isDisabled,
	isInRange = false,
	isRangeStart = false,
	isRangeEnd = false,
	onClick,
	onMouseEnter,
	onMouseLeave,
}) => {
	const [isHovered, setIsHovered] = React.useState(false)

	const handleClick = () => {
		// Клик возможен только для дат текущего месяца и не disabled
		if (isCurrentMonth && !isDisabled) {
			onClick(date)
		}
	}

	const handleMouseEnter = () => {
		setIsHovered(true)
		onMouseEnter?.()
	}

	const handleMouseLeave = () => {
		setIsHovered(false)
		onMouseLeave?.()
	}

	return (
		<StyledDayCell
			$isSelected={isSelected}
			$isToday={isToday}
			$isCurrentMonth={isCurrentMonth}
			$isDisabled={isDisabled}
			$isInRange={isInRange}
			$isRangeStart={isRangeStart}
			$isRangeEnd={isRangeEnd}
			onClick={handleClick}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			{isRangeStart && (
				<RangeArrow
					$position='right'
					$isHovered={isHovered}
					viewBox='0 0 16 36'
				>
					<path
						d='M 0 0 L 12 18 L 0 36'
						fill={COLORS.main}
						stroke={COLORS.main}
						strokeWidth='2'
						strokeLinejoin='round'
					/>
				</RangeArrow>
			)}
			{isRangeEnd && (
				<RangeArrow $position='left' $isHovered={isHovered} viewBox='0 0 16 36'>
					<path
						d='M 16 0 L 4 18 L 16 36'
						fill={COLORS.main}
						stroke={COLORS.main}
						strokeWidth='2'
						strokeLinejoin='round'
					/>
				</RangeArrow>
			)}
			<DayCellContent>{date.format('D')}</DayCellContent>
		</StyledDayCell>
	)
}

export default DayCell
